module.exports = __webpack_public_path__ + "static/media/LS035Q7DD01_SPEC_LD2023702A.b27cda76.jpg";